module.exports = __webpack_public_path__ + "img/photo-29.f2b2ff32.webp";